const ddmmyyyy = /^(\d{2})\/(\d{2})\/(\d{4})$/

export const toOptions = (array = [], labelTransform) =>
  array.reduce((options, value) => {
    if (value) options.push({ value, label: labelTransform ? labelTransform(value) : value })
    return options
  }, [])

export const renamePubType = (publicationTypes, pubType, attribute = 'name') =>
  publicationTypes?.[pubType]?.[attribute] || publicationTypes?.[pubType]?.name || ''

export const dateStrToISODate = date => new Date(date.replace(ddmmyyyy, '$3-$2-$1'))

export const withLoading =
  ({ setLoading }) =>
  func =>
  async (...props) => {
    setLoading(true)
    await func(...props)
    setLoading(false)
  }

export const isDitaContent = content => !content.size

export const isEmpty = obj => !obj || Object.keys(obj).length === 0

export const isObject = obj => Object.prototype.toString.call(obj) === '[object Object]'

/**
 * Returns a new object with a new structure
 * @example
 * toKeyAsIdAndValueAsLabel({ A: 'a', B: 'b' }) // returns { A: { id: 'A', label: 'a' }, B: { id: 'B', label: 'b' } }
 * @param obj
 * @returns {{}}
 */
export const toKeyAsIdAndValueAsLabel = obj =>
  Object.entries(obj).reduce((obj, [key, value]) => {
    obj[key] = { id: key, label: value }
    return obj
  }, {})

export const formatDate = date => {
  let d = new Date(date)
  const tzOffset = d.getTimezoneOffset() * 60000
  d = new Date(d.getTime() + tzOffset)
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
}

export const isServer = () => typeof window === 'undefined'
